import { REDUX_MODEL_KEY } from '../../constants/key'

import createReduxUtil from '../create'
import getUpdatedDataReduxUtil from '../get-updated-data'
import { MODEL_KEY } from '../../../model/constants'
import { omitObjectUtil } from 'packages/src'

const FOREIGN_KEYS_THAT_SHOULD_BE_KEPT = [
  'exerciseId',
  'parentId',
  'planId'
]

export function cloneDataReduxUtil (params) {
  const {
    data,
    keysToOmit = [],
    shouldKeepIds,
    shouldKeepForeignIds = true
  } = params
  const newData = omitObjectUtil(data, [
    ...Object.values(shouldKeepIds ? {} : MODEL_KEY),
    ...keysToOmit
  ])

  return Object.keys(newData)
    .reduce((obj, key) => {
      // If it's foreign key, set it to null
      if (!shouldKeepForeignIds &&
        key.endsWith('Id') &&
        !FOREIGN_KEYS_THAT_SHOULD_BE_KEPT.includes(key)) {
        obj[key] = null
      } else {
        obj[key] = data[key]
      }
      return obj
    }, {})
}

export default function cloneReduxUtil (params) {
  const {
    instance,
    updates = {},
    keysToOmit = [],
    shouldKeepForeignIds
  } = params

  if (!instance) {
    return
  }

  const changed = {
    ...cloneDataReduxUtil({
      data: getUpdatedDataReduxUtil(instance),
      keysToOmit,
      shouldKeepForeignIds
    }),
    ...updates
  }

  return createReduxUtil({
    className: instance[REDUX_MODEL_KEY.CLASS_NAME],
    changed
  })
}
